// Copied from https://github.com/wwdrew/react-native-numeric-textinput/blob/master/src/NumericTextInput.js
import React, { forwardRef } from "react";
import { TextInput, ITextInput } from "ui-components";

type NumericTextInputType = "currency" | "decimal";
type NumericTextInputOptionsType = {
  currency?: string;
  decimalPlaces?: number;
  useGrouping?: boolean;
  errors?: any;
};
type Props = NumericTextInputOptionsType & {
  locale?: string;
  name?: string;
  keyboardType?: any;
  onChangeText: (value?: number) => any;
  disabled?: boolean;
  type?: NumericTextInputType;
  value: number | string;
  inputAccessoryViewID: string;
  onFocus: any;
  testID?: string;
  accessibilityLabel?: string;
} & ITextInput;
type NumberFormatConfig = {
  divisor: number;
  type: NumericTextInputType;
  locale: string;
  minimumFractionDigits: number;
};

const createFormatConfig = (props: Props) => {
  const { locale = "en", type = "currency", useGrouping = true } = props;
  const typeOptions: any = {};
  let { decimalPlaces = 0 } = props;

  if (type === "currency") {
    const { currency = "USD" } = props;

    typeOptions.currency = currency;
    decimalPlaces = 2;
  } else {
    typeOptions.minimumFractionDigits = decimalPlaces;
  }

  return Object.assign({}, typeOptions, {
    locale,
    style: type,
    useGrouping,
    divisor: Math.pow(10, decimalPlaces),
  });
};
const formatNumberValue = (numberValue: number, numberFormatConfig: NumberFormatConfig) => {
  let returnValue = "";

  if (numberValue) {
    const { locale, ...config } = numberFormatConfig;

    returnValue = new Intl.NumberFormat(locale, config).format(numberValue);
  }

  return returnValue;
};

const parseStringValue = (text: string, numberFormatConfig: NumberFormatConfig) => {
  const digitsOnly = text.match(/\d+/g);

  return digitsOnly ? parseInt(digitsOnly.join(""), 10) / numberFormatConfig.divisor : undefined;
};

const onUpdate = (onChangeText: any, formatConfig: NumberFormatConfig) => (text: any) => {
  let parsedValue = parseStringValue(text, formatConfig);

  if (onChangeText) {
    onChangeText(parsedValue);
  }
};

export const NumericInputNew = forwardRef((props: Props, ref: any) => {
  const { onChangeText, keyboardType = "number-pad", value, name = "", ...textInputProps } = props;
  const formatConfig = createFormatConfig(props);
  return (
    <TextInput
      mode="outlined"
      keyboardType={keyboardType}
      value={formatNumberValue(value, formatConfig)}
      onChangeText={onUpdate(onChangeText, formatConfig)}
      ref={ref}
      {...textInputProps}
    />
  );
});
